import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-8 w-auto',
  md: 'h-10 w-auto',
  lg: 'h-14 w-auto',
};

export const Logo: React.FC<LogoProps> = ({ className, size = 'md' }) => {
  const appliedClass = className || sizeClasses[size];
  
  return (
    <a href="/" className="block hover:opacity-80 transition-opacity">
      <img
        src="/cemates-imza-siyah-logo.png"
        alt="Huseyin Cem Ates Logo"
        className={`${appliedClass} dark:invert`}
      />
    </a>
  );
};
